<template>
<v-container fluid class="fill-height secondary lighten-1 gradient">
  <v-row align="center" justify="center">

    <v-col cols="12" sm="10" md="7" lg="6" xl="4">
      <v-card class="secondary">
        <v-card-actions class="text-center justify-center py-2 white-gradient">
          <router-link class="nolink" to="/brands">
            <div class="logofont text-shadow pt-4">
            <span class="primary--text">Why</span>
            <span class="secondary--text">Buy</span>
          </div>
          <div class="raleway secondary--text pb-4">CONTESTS</div>
          </router-link>

        </v-card-actions>
        <v-tabs v-model="tab" background-color="secondary" dark :grow="true" :slider-size="5">
          <v-tabs-slider color="primary"></v-tabs-slider>
          <v-tab :href="`#login`" tile>
            Sign In
          </v-tab>
          <v-tab :href="`#register`" tile>
            Sign Up
          </v-tab>
          <v-tab :href="`#forgot`" hide style="display:none">
          </v-tab>
          <v-tab :href="`#reset`" hide style="display:none">
          </v-tab>

          <v-tab-item value="reset">
            <reset @tab="switchTab"></reset>
          </v-tab-item>
          <v-tab-item value="forgot">
            <forgot @tab="switchTab"></forgot>
          </v-tab-item>
          <v-tab-item value="login">
            <login @tab="switchTab"></login>
          </v-tab-item>
          <v-tab-item value="register">
            <register @tab="switchTab"></register>
          </v-tab-item>
        </v-tabs>
      </v-card>
    </v-col>
  </v-row>

</v-container>
</template>
<script>
import login from "@/components/login-business/login"
import register from "@/components/login-business/register"
import reset from "@/components/login-business/reset"
import forgot from "@/components/login-business/forgot"

export default {
  name: "",
  components: {
    login,
    register,
    reset,
    forgot
  },
  data: () => ({
    tab: 'login',
  }),
  methods: {
    switchTab(tab) {
      this.tab = tab;
    }
  },
  computed: {

  },
  created() {
    if (this.$route.query.token) {
      setTimeout(function() {
        this.tab = 'reset'
      }.bind(this), 100)
    }
    if (this.$route.hash.includes("forgot")){
      setTimeout(function() {
        this.tab = 'forgot'
      }.bind(this), 100)
    }
    if (this.$route.query.continue) {
      this.$store.commit('account/set_continue', this.$route.query.continue)
    }
  }
}
</script>
<style lang="scss" scoped>
@font-face {
    font-family: "Arial Rounded MT Bold";
    src: url("/fonts/ArialRoundedMTBold.ttf"), url("/fonts/ArialRoundedMTBold.eot?"), url("/fonts/ArialRoundedMTBold.svg");
}

.logofont {
    font-family: 'Arial Rounded MT Bold', sans-serif;
    font-size: 64px;
    letter-spacing: -3.3px;
}

.gradient {
    background: #FC466B;
    /* fallback for old browsers */
    background: -webkit-linear-gradient(to right, #3F5EFB, #FC466B);
    /* Chrome 10-25, Safari 5.1-6 */
    background: linear-gradient(to right, #3F5EFB, #FC466B);
    /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */

}
.bg {
    background-size: cover;
    background-position-y: center;
    background-position-x: center;
    z-index: 0;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
}
</style>
